import cn from 'classnames';
import React from 'react';

import { Button, Icon } from '@sravni/react-design-system';
import { ThumbUp } from '@sravni/react-icons';

import styles from './like-btn.module.scss';

interface ILikeArticleButton {
  likesCount: number | undefined;
  isLiked: boolean | undefined;
  onToggleLike: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const LikeArticleButton: React.FC<ILikeArticleButton> = ({ likesCount, isLiked, onToggleLike }) => {
  return (
    <Button onClick={onToggleLike} size={36} variant="outlined" color="dark" name={'Нравится'}>
      {likesCount > 0 && likesCount}
      <Icon size={20} icon={<ThumbUp className={cn(styles.icon, isLiked && styles.filled)} />} />
    </Button>
  );
};
